'use client';
import { Button } from '@nf/ui';
import {
	GvIcon,
	StreamerIcon,
	VideoIcon,
} from '@/components/icons/svg-icons';
import { cx } from 'styled-system/css';
import { SportMatchModel } from '@nf/types/odds';
import { useLocale } from 'next-intl';
import { useSetAtom } from 'jotai';
import { pageSideMatchIdAtom } from '@/atoms/odds-page';
import { useRouter } from '@/navigation';
import { StatisticButton } from '@/components/feature-buttons/statistic-button';
import { MiniStreamingButton } from '@/components/feature-buttons/mini-streaming-button';
import { useAccountInfo } from '@/hooks/query/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAuthToken } from '@/store/auth';
import { streamingService } from '@/services/streaming.service';
import { StreamingType, useStreamingStore } from '@/store/streaming';
import { isDesktop } from 'react-device-detect';
import { CashoutIcon } from '@/components/icons/cashout-icon';
import { matchStyles } from '../../match/match.style';
import { matchSpecialStyles } from '../match-special.style';
import { useAppearanceStore } from '@/store/appearance';
import { KafkaNote } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { ViewEnum } from '@/types';
import { useParams } from 'next/navigation';
import { useSlmtGv } from '@/hooks/query/use-slmt-gv';
interface MatchSpecialOptionProps {
	match: SportMatchModel;
}

/**
 * [Mars] Odds Page > Match Optoion
 * @description 此元件顯示於 all width 老鳥版 (for sport 6,9,50)
 * @see MatchOption
 */
export const MatchSpecialOption = ({ match }: MatchSpecialOptionProps) => {
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const authToken = useAuthToken();
	const { sport } = useParams();
	const isBefore = !Boolean(authToken);
	const { hasVideo, hasStreamer, hasLSports } = streamingService.getVideoOptions(match, true, SiteConfigsData, user);
	const { MatchId, MaT, GameID, LeagueId, IsLive } = match;
	const { hasSlmtGv } = useSlmtGv({ match, sport });
	const setPageSideMatchId = useSetAtom(pageSideMatchIdAtom);
	const [setStreamingType, setStreamingStatus] = useStreamingStore(
		state => [state.setStreamingType, state.setStreamingStatus],
	);
	const view = useAppearanceStore(state => state.view);
	const router = useRouter();
	const locale = useLocale();
	const singleMatchHref = `/sports/${GameID}/${MaT}/${LeagueId}/${MatchId}`;

	const handleVisitSingleMatch = () => {
		router.push(singleMatchHref), { locale };
		setStreamingStatus('', '', []);
	}

	const handleStreamingButtonClick = (type: StreamingType) => {
		setKafka(type);

		if (isDesktop) {
			setPageSideMatchId(MatchId)
		} else {
			handleVisitSingleMatch();
		}
		if (IsLive) {
			setStreamingType(type);
		}
	}

	const setKafka = (type: StreamingType) => {
		if (view !== ViewEnum.mars) return;

		const isShowRightMenu = window.innerWidth >= 1250;
		let action;
		switch (type) {
			case 'Streamer':
				action = isShowRightMenu ? 15: 2;
				break;
			case 'Streaming':
				action = isShowRightMenu ? 16: 3;
				break;
			case 'GV':
				action = isShowRightMenu ? 17: 4;
				break;
		}

		if (action) {
			const kafkaData = {
				note: KafkaNote.MarsV1,
				type: 6,
				action
			}
			setKafkaNormal(kafkaData);
		}
	}
	
	return (
		<div className={cx('match-info', matchStyles.info, matchSpecialStyles.info)}>
			<div className={matchStyles.option}>
				{
					hasStreamer !== 0 && !isBefore ? 
						<Button
							variant={'icon'}
							onClick={() => handleStreamingButtonClick('Streamer')}
						>
							<StreamerIcon />
						</Button>
						: null
				}
				{
					hasVideo && !isBefore ?
						<Button
							variant={'icon'}
							onClick={() => handleStreamingButtonClick('Streaming')}
						>
							<VideoIcon />
						</Button>
						: null
				}
				{
					hasSlmtGv ?
						<Button
							variant={'icon'}
							onClick={() => handleStreamingButtonClick('SlmtGV')}
						>
							<GvIcon />
						</Button>
						: null
				}
				<StatisticButton match={match} isNeedSetMatchId={true} />
				<CashoutIcon match={match} />
			</div>
			{
				hasVideo && !isBefore && IsLive ?
					<MiniStreamingButton match={match} /> : null
			}
		</div>
	)
}
